"use client";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";

interface ReplaceUrlProps {
	newUrl: string;
}

const ReplaceUrl: React.FC<ReplaceUrlProps> = ({ newUrl }) => {
	const router = useRouter();
	useEffect(() => {
		router.replace(newUrl);
	}, [newUrl, router]);
	return null;
};

export default ReplaceUrl;
